import { RouteDestination } from "../redux/services/types";

export const routeDestinationName = (
  destination: RouteDestination,
  language: string,
): string => {
  const label = destination.labels?.name || destination.labels?.long;
  if (typeof label === "string") return label;
  return (
    label?.[language] ||
    label?.["en-GB"] ||
    Object.values(label || {})[0] ||
    `${destination.latitude.toFixed(5)}, ${destination.longitude.toFixed(5)}`
  );
};
